import {
  call, put, takeLatest, delay,
} from 'redux-saga/effects';
import { wsClient } from '../util/appUtils';
import { enqueueErrorSnackbar } from '../actions/Notifications';
import { getLocalizedMessage } from '../util/useLocalizedNotifications';
import {
  fetchCatalogStatus,
  fetchCatalogStatusSuccess,
  fetchCatalogStatusFailure,
  fetchCatalogHistory,
  fetchCatalogHistorySuccess,
  fetchCatalogHistoryFailure,
  triggerCatalogUpdate,
  triggerCatalogUpdateSuccess,
  triggerCatalogUpdateFailure,
} from '../slices/catalogSyncSlice';

function* handleFetchCatalogStatus(action) {
  try {
    const { shopId } = action.payload || {};
    if (!shopId) {
      const errorMsg = getLocalizedMessage('catalog.sync.shopRequiredForStatus');
      yield put(fetchCatalogStatusFailure(errorMsg));
      yield put(enqueueErrorSnackbar(errorMsg));
      return;
    }
    const response = yield call(wsClient.getCatalogSyncStatus, shopId);
    yield put(fetchCatalogStatusSuccess(response));
  } catch (error) {
    console.error('Error fetching catalog status:', error);
    const errorMsg = error.message || getLocalizedMessage('catalog.sync.statusFetchFailed');
    yield put(fetchCatalogStatusFailure(errorMsg));
    if (error.status === 401) {
      yield put(enqueueErrorSnackbar(getLocalizedMessage('auth.credentialsRequired')));
    } else {
      yield put(enqueueErrorSnackbar(errorMsg));
    }
  }
}

function* handleFetchCatalogHistory(action) {
  try {
    const { shopId } = action.payload || {};
    if (!shopId) {
      const errorMsg = getLocalizedMessage('catalog.sync.shopRequiredForHistory');
      yield put(fetchCatalogHistoryFailure(errorMsg));
      yield put(enqueueErrorSnackbar(errorMsg));
      return;
    }
    const response = yield call(wsClient.getCatalogSyncHistory, shopId);
    yield put(fetchCatalogHistorySuccess(response));
  } catch (error) {
    console.error('Error fetching catalog history:', error);
    const errorMsg = error.message || getLocalizedMessage('catalog.sync.historyFetchFailed');
    yield put(fetchCatalogHistoryFailure(errorMsg));
    if (error.status === 401) {
      yield put(enqueueErrorSnackbar(getLocalizedMessage('auth.credentialsRequired')));
    } else {
      yield put(enqueueErrorSnackbar(errorMsg));
    }
  }
}

function* handleTriggerCatalogUpdate(action) {
  try {
    const { shopId } = action.payload || {};
    if (!shopId) {
      const errorMsg = getLocalizedMessage('catalog.sync.shopRequiredForUpdate');
      yield put(triggerCatalogUpdateFailure(errorMsg));
      yield put(enqueueErrorSnackbar(errorMsg));
      return;
    }
    const response = yield call(wsClient.submitCrawlerTask, shopId);
    yield put(triggerCatalogUpdateSuccess(response));

    // Refresh status and history after a short delay to see the new task
    yield delay(1000);
    yield put(fetchCatalogStatus({ shopId }));
    yield put(fetchCatalogHistory({ shopId }));
  } catch (error) {
    console.error('Error triggering catalog update:', error);
    const errorMsg = error.message || getLocalizedMessage('catalog.sync.updateStartFailed');
    yield put(triggerCatalogUpdateFailure(errorMsg));
    if (error.status === 401) {
      yield put(enqueueErrorSnackbar(getLocalizedMessage('auth.updateCredentialsRequired')));
    } else {
      yield put(enqueueErrorSnackbar(errorMsg));
    }
  }
}

export default function* catalogSyncSaga() {
  yield takeLatest(fetchCatalogStatus.type, handleFetchCatalogStatus);
  yield takeLatest(fetchCatalogHistory.type, handleFetchCatalogHistory);
  yield takeLatest(triggerCatalogUpdate.type, handleTriggerCatalogUpdate);
}
